import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import IkTable from "@Components/IkTable";
import dataHandler from "@Utils/dataHandler";
import styles from "./styles.module.css";

const MensajeUsuariosTable = ({ dispatch, companyName, userName, onOpenFilterModal, appliedFilters = {} }) => {
	const defaultParams = { page: 1, orderKey: "total", orderDir: "desc", rows: 20 };
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(0);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [lastParams, setLastParams] = useState(defaultParams);
	const [sumData, setSumData] = useState({});

	useEffect(() => {
		const mergedParams = { ...defaultParams, ...appliedFilters };
		(async () => {
			const response = await dataHandler({
				dispatch,
				url: "/chats/mensajeUsuarios",
				params: mergedParams,
			});
			setFilteredItems(response.items || []);
			setFilteredCount(response.count || 0);
			setSumData(response.total || {});
			setLastParams(mergedParams);
		})();
	}, [dispatch, appliedFilters]);

	const handlerData = async (params = defaultParams, printable) => {
		const mergedParams = { ...params, ...appliedFilters };
		const response = await dataHandler({
			dispatch,
			url: "/chats/mensajeUsuarios",
			params: mergedParams,
		});
		if (printable) setFilteredPrintData(response.items || []);
		else {
			setFilteredItems(response.items || []);
			setFilteredCount(response.count || 0);
			setSumData(response.total || {});
			setLastParams(mergedParams);
		}
	};

	const handleRefreshData = () => {
		handlerData(lastParams);
	};

	const renderTopButtons = () => {
		const isFiltering = Object.keys(appliedFilters).length > 0;
		return [
			{
				icon: "filter",
				className: isFiltering ? styles.filterButtonActive : styles.filterButton,
				onClick: onOpenFilterModal,
				content: isFiltering ? "Filtrando" : "",
				label: isFiltering ? "Filtrando" : "",
				showLabel: true,
				componentType: "button",
			},
			{
				icon: "refresh",
				className: styles.refreshButton,
				onClick: handleRefreshData,
			},
		];
	};

	return (
		<div className={styles.container}>
			<div className={styles.containerTableGroup}>
				<div className={styles.tableGroupList}>
					<IkTable
						data={filteredItems}
						columns={[
							{ label: "Usuario", key: "userName", format: "string", dataPosition: "left", width: 2 },
							{ label: "Cnt Mensaje", key: "cntMensaje", format: "string", dataPosition: "center", width: 1 },
							{ label: "A Tiempo", key: "atiempo", format: "string", dataPosition: "center", width: 1 },
							{ label: "En Atraso", key: "atraso", format: "string", dataPosition: "center", width: 1 },
							{ label: "Vencido", key: "vencido", format: "string", dataPosition: "center", width: 1 },
							{ label: "Total", key: "total", format: "string", dataPosition: "center", width: 1, sum: true },
						]}
						totalRows={filteredCount}
						filteredPrintData={filteredPrintData}
						defaultParams={defaultParams}
						dataHandler={handlerData}
						print={{
							printHeader: {
								company: companyName,
								title: "Usuarios - Cantidad de Mensajes por Estado",
								user: userName,
							},
						}}
						searcher={{
							searchable: true,
							searchPosition: "flex-start",
							searchDisabled: false,
							filterButton: false,
							width: "40rem",
						}}
						widthAuto
						topButtons={renderTopButtons()}
						sumData={sumData}
					/>
				</div>
			</div>
		</div>
	);
};

MensajeUsuariosTable.propTypes = {
	dispatch: PropTypes.func,
	companyName: PropTypes.string,
	userName: PropTypes.string,
	onOpenFilterModal: PropTypes.func,
	appliedFilters: PropTypes.object,
};

export default connect()(MensajeUsuariosTable);
